var _ = require('lodash');
var angular = require('angular');
import TopBar from 'rawr/controls/TopBar';
var m = require('am');

m.value('TopBar', TopBar);

m.directive('topBar', [function() {
  return {
    scope: {},
    template: `
      <react-component name="TopBar" props="props" watch-depth="value" />
    `,
    replace: true,
    controller: ['$scope', '$injector', '$state', '$rootScope',
     function($scope, $injector, $state, $rootScope) {
      $scope.props = {};

      //Loading animation trigger
      function start() {
        $scope.props.loading = true;
      }
      function stop() {
        $scope.props.loading = false;
      }
      $scope.$on('$stateChangeStart', start);
      _.forEach(['$stateChangeSuccess', '$stateChangeError', '$stateNotFound', '$overlayShow', '$stateChangeCancelled'], function(name) {
        $scope.$on(name, stop);
      });

      $rootScope.$on('userLoginSuccess', function() {
        $scope.props.loggedIn = Date.now();
      });

      $scope.$on('$stateChangeSuccess', function(ev, toState, toParams) {
        if (toState.data) {
          let app_link = toState.data.app_link;

          if (app_link && (typeof app_link === 'function' || (app_link.slice && typeof app_link.slice(-1)[0] === 'function'))) {
            $scope.props.app = $injector.invoke(app_link, $injector, $state.$current.locals.globals);
          } else {
            $scope.props.app = app_link;
          }
        }
      });
    }]
  };
}]);



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/TopBar/TopBar.js
 **/